export enum TitleActionType {
    SET_TITLE = 'SET_TITLE'
}